import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';

import { TranslocoModule } from '@ngneat/transloco';

import { DirectiveModule } from '@shared/directives/directive.module';
import { IconModule } from '@shared/icon/icon.module';
import { MaterialModule } from '@shared/material.module';
import { PipesModule } from '@shared/pipes/pipes.module';

import { ValidationMessageModule } from '../validation-message/validation-message.module';
import { VSCSelectComponent } from './select.component';

@NgModule({
    declarations: [VSCSelectComponent],
    imports: [
        CommonModule,
        TranslocoModule,
        FormsModule,
        ValidationMessageModule,
        MaterialModule,
        FlexLayoutModule,
        PipesModule,
        DirectiveModule,
        IconModule,
    ],

    exports: [VSCSelectComponent],
})
export class VscSelectModule {}
